export default {"src":"/_next/static/media/paoer-plane.7d4bbefd.svg","height":39,"width":54,"blurWidth":0,"blurHeight":0};